import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAgentsLoading = (isLoading) => ({
  type: actionTypes.SET_AGENTS_LOADING,
  payload: isLoading
})
